export const PROMPT_TYPES: { label: string; value: string }[] = [
  { label: "Organic", value: "organic" },
  { label: "Competitor", value: "competitor" },
  { label: "Brand Specific", value: "brand_specific" },
];
